export default () => {
	const favoriteBtns = document.querySelectorAll("[data-favorite]")

	const mapEventDelegation = document.querySelector("#map")

	if (favoriteBtns && favoriteBtns.length > 0) {
		favoriteBtns.forEach((btn) => {
			btn.addEventListener("click", function (e) {
				e.preventDefault()
				e.stopPropagation()

				const type = this.dataset.type,
					editableCookie = document.cookie.split(";"),
					that = this

				let updatedCookie = null

				this.classList.add("favorite")

				editableCookie.map((item) => {
					if (item.indexOf(`favorite_${type}`) >= 0) {
						const compareItems = JSON.parse(item.split("=")[1]);

						let newArray = [];
						const favId = parseInt(that.dataset.favorite);
						if (compareItems.indexOf(favId) == -1)
							newArray = [
								...new Set([...compareItems, +favId]),
							]
						else {
							newArray = compareItems.reduce(
								(previousValue, currentValue) => {
									if (currentValue !== +favId) {
										return [...previousValue, currentValue]
									}
									return previousValue
								},
								[]
							)
						}

						updatedCookie = `favorite_${type}=${JSON.stringify(
							newArray
						)}; path=/`
					}
				})

				document.cookie = updatedCookie
					? updatedCookie
					: `favorite_${type}=${JSON.stringify([
						+that.dataset.favorite,
					])}; path=/`


				refreshFavoriteMenu();
			})
		})
	}

	if (mapEventDelegation) {
		mapEventDelegation?.addEventListener("click", function (e) {
			let favoriteID = null,
				favoriteType = null
			if (e.target.hasAttribute("data-favorite")) {
				favoriteID = parseInt(e.target.getAttribute("data-favorite"))
				favoriteType = e.target.getAttribute("data-type")
				e.target.classList.add("favorite")
			}

			if (e.target.closest("[data-favorite]")) {
				favoriteID = parseInt(e.target
					.closest("[data-favorite]")
					.getAttribute("data-favorite"))
				favoriteType = e.target
					.closest("[data-favorite]")
					.getAttribute("data-type")

				e.target.closest("[data-favorite]").classList.add("favorite")
			}

			if (favoriteID !== null) {
				const editableCookie = document.cookie.split(";")

				let updatedCookie = null

				// this.classList.add("favorite")

				editableCookie.map((item) => {
					if (item.indexOf(`favorite_${favoriteType}`) >= 0) {
						const compareItems = JSON.parse(item.split("=")[1])

						let newArray = [];
						console.log(favoriteID, compareItems);
						if (compareItems.indexOf(favoriteID) == -1)
							newArray = [
								...new Set([...compareItems, +favoriteID]),
							]
						else {
							newArray = compareItems.reduce(
								(previousValue, currentValue) => {
									if (currentValue !== +favoriteID) {
										return [...previousValue, currentValue]
									}
									return previousValue
								},
								[]
							)
						}


						updatedCookie = `favorite_${favoriteType}=${JSON.stringify(
							newArray
						)}; path=/`;

					}
				})

				document.cookie = updatedCookie
					? updatedCookie
					: `favorite_${favoriteType}=${JSON.stringify([+favoriteID])}; path=/`
			}
			refreshFavoriteMenu();
		})
	}

	const removeCompereItemBtns = document.querySelectorAll(
		".page-template-page-favorite [data-remove]"
	)

	if (removeCompereItemBtns?.length > 0) {
		removeCompereItemBtns.forEach((item) => {
			item.addEventListener("click", function (e) {
				const editableCookie = document.cookie.split(";"),
					type = this.dataset.type

				editableCookie.map((item) => {
					if (item.indexOf(`favorite_${type}`) >= 0) {
						const compareItems = JSON.parse(item.split("=")[1])

						const newArray = compareItems.reduce(
							(previousValue, currentValue) => {
								if (currentValue !== +this.dataset.remove) {
									return [...previousValue, currentValue]
								}
								return previousValue
							},
							[]
						)


						document.cookie = `favorite_${type}=${JSON.stringify(
							newArray
						)}; path=/`

						refreshFavoriteMenu();
					}
				})

				const target = e.currentTarget;
				target.closest(".favorite-wrapper").remove();

			})
		})
	}


	const refreshFavoriteMenu = (favoriteType, newArray) => {
		const browserCookie = document.cookie.split(";"),
			favoriteElement = document.querySelector(".user-menu__favorite"),
			compareElement = document.querySelector(".user-menu__compare");

		document.querySelectorAll("[data-favorite]").forEach((item) => {
			item.classList.remove("favorite");
		})

		if (Array.isArray(browserCookie)) {
			var totalFavs = 0;
			var totalComps = 0;


			browserCookie.forEach((item) => {
				if (item.indexOf(`favorite_warehouse`) >= 0) {
					const favItems = JSON.parse(item.split("=")[1]);
					if (Array.isArray(favItems)) {
						if (document.querySelector(".fav-warehouse-num")) {
							if (favItems.length)
								document.querySelector(".fav-warehouse-num").innerHTML = ' (' + favItems.length + ')';
							else
								document.querySelector(".fav-warehouse-num").innerHTML = '';
						}

						favoriteElement.setAttribute(`data-count-warehouse`, favItems.length);
						totalFavs += favItems.length;

						favItems.forEach((itemId) => {
							if (document.querySelector("[data-favorite='" + itemId + "']"))
								document.querySelectorAll("[data-favorite='" + itemId + "']").forEach((item) => {
									item.classList.add("favorite");
								});
						})
					}
				}
				if (item.indexOf(`favorite_land`) >= 0) {
					const favItems = JSON.parse(item.split("=")[1]);
					if (Array.isArray(favItems)) {
						if (document.querySelector(".fav-land-num")) {
							if (favItems.length)
								document.querySelector(".fav-land-num").innerHTML = ' (' + favItems.length + ')';
							else
								document.querySelector(".fav-land-num").innerHTML = '';
						}
						favoriteElement.setAttribute(`data-count-office`, favItems.length)
						totalFavs += favItems.length;

						favItems.forEach((itemId) => {
							if (document.querySelector("[data-favorite='" + itemId + "']"))
								document.querySelectorAll("[data-favorite='" + itemId + "']").forEach((item) => {
									item.classList.add("favorite");
								});
						})
					}
				}
				if (item.indexOf(`favorite_office`) >= 0) {
					const favItems = JSON.parse(item.split("=")[1]);
					if (Array.isArray(favItems)) {

						if (document.querySelector(".fav-office-num")) {
							if (favItems.length)
								document.querySelector(".fav-office-num").innerHTML = ' (' + favItems.length + ')';
							else
								document.querySelector(".fav-office-num").innerHTML = '';
						}

						favoriteElement.setAttribute(`data-count-land`, favItems.length)
						totalFavs += favItems.length;

						favItems.forEach((itemId) => {
							if (document.querySelector("[data-favorite='" + itemId + "']"))
								document.querySelectorAll("[data-favorite='" + itemId + "']").forEach((item) => {
									item.classList.add("favorite");
								});
						})
					}
				}

				if (totalFavs > 0) {
					favoriteElement.setAttribute("data-count", totalFavs)
				} else {
					favoriteElement.removeAttribute("data-count");
				}

			});

		}
		;
	}
	refreshFavoriteMenu();

	document.addEventListener("refresh-favs", refreshFavoriteMenu);
}
